<template>
  <div class="h-100">
    <common ref="common"/>
    <!-- <v-row>
      <v-col v-for="(ap, apIndex) in authorityPersons" :key="apIndex" :cols="6">
        <v-card>
          <v-img
            height="100"
            width="100"
            :src="$url + ap.storedUrl"
            contain
          ></v-img>
        </v-card>
        </v-col>
    </v-row> -->

    <!-- <div class="ColumnContainer"> -->
    <!-- <div class="ScrollContainer"> -->
    <!-- <v-col cols="12"> -->
    <v-container class="bg-surface-variant px-0">
      <v-row>
        <v-col
          cols="12"
          xs="6"
          sm="6"
          class="px-2"
          v-for="(member, index) in membersList"
          :key="index"
        >
          <v-card class="mx-auto rounded-xl" elevation="12" max-width="100%">
            <v-card-text>
              <div class="d-flex" style="gap: 20px;">
                <v-avatar v-if="member.storedUrl" size="70px">
                  <img :src="$url + member.storedUrl" />
                </v-avatar>
                <v-avatar v-else size="70px" color="grey lighten-1">
                  <v-icon class="mdi-36px white--text">mdi-image</v-icon>
                </v-avatar>
                <!-- <div class="d-flex  justify-center align-center">
                <div>
                  <h4>{{ member.memberName }}</h4>
                  <v-chip>{{ member.designation }}</v-chip>
                </div>
                <div class="text-right">
                  <v-btn fab dark x-small color="#28D146"> <v-icon>mdi-whatsapp</v-icon></v-btn>
                  <v-btn fab dark x-small color="#0DACF4"> <v-icon>mdi-phone</v-icon></v-btn>
                </div>
                </div> -->
                <v-row no-gutters>
                  <v-col cols="8">
                    <h4>{{ member.memberName }}</h4>
                  <v-chip>{{ member.designation }}</v-chip>
                  </v-col>
                  <v-col cols="4" class="d-flex align-center justify-end" style="column-gap: 5px;" @click="startChat()">
                    <a :href="`https://wa.me/+91${member.mobileNo}`" style="text-decoration: none;">
                    <v-btn fab dark x-small color="#28D146"> <v-icon>mdi-whatsapp</v-icon></v-btn>
                   </a>
                  <a :href="`tel:${member.mobileNo}`" style="text-decoration: none;">
                  <v-btn fab dark x-small color="#0DACF4" @click="makePhoneCall()"> <v-icon>mdi-phone</v-icon></v-btn>
                </a>
                  </v-col>
                </v-row>
              </div>
            </v-card-text>

            <!-- <v-row>
                <v-col
                  cols="4"
                  class="text-center"
                >
                  <v-avatar v-if="member.storedUrl" size="70px">
                    <img :src="$url + member.storedUrl" />
                  </v-avatar>
                  <v-avatar v-else size="70px" color="grey">
                    <v-icon class="mdi-36px">mdi-account</v-icon>
                  </v-avatar>
                </v-col>
                <v-col cols="8" class="mx-auto">
                      <h4>{{ member.memberName }}</h4>
                      <div>
                      <v-chip>{{ member.designation }}</v-chip>

                      </div>
                </v-col>
              </v-row> -->
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <div
      class="d-flex justify-end"
      style="position: fixed;bottom:70px;right: 20px;"
    >
    <!-- <a :href="byLowsrc" download> -->
      <v-btn color="primary" dark fab @click="getByLow1">
        <v-icon>mdi-download</v-icon>
      </v-btn>
    <!-- </a> -->
    </div>
    <!-- <Bylow/> -->
    <!-- </div> -->
    
  </div>
</template>
<script>
import { callApi } from "@/api/others";
export default {
  components: { 
    common:()=>import("@/components/tools/common.vue")
   },
  data: () => ({
    membersList: [],
    byLowsrc: "",
    imageloc:require("@/assets/Images/DownArrow.png")
  }),
  mounted() {
    this.getAuthorityPersons();
    this.$emit("changeHeader","<span style='font-size: small;'>VYAPARI VYAVASAYI <br/> EKOPANA SAMITHI PALAKKAD</span>");
   
    // this.getByLow();
  },
  methods: {
    getAuthorityPersons() {
      this.dpLoading = true;
      let url = "/api/wesupport/Member/GetAuthorityPersons";
      callApi(url, "get", "")
        .then((res) => {
          this.membersList = res.data.data;
        })
        .catch((err) => {})
        .finally(() => {
          this.dpLoading = false;
        });
    },
    async getByLow1(){
      this.dpLoading = true;
      let url = `/api/wesupport/Member/GetByLaw`;
      await callApi(url,"post","","blob")
      .then((response)=>{
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.download = "Bye -Law & MOA merged.pdf";
        document.body.appendChild(link);
        link.click();
      })
      .catch((err)=>{
        console.log(err);
        this.$refs.common.ManageResponse(err.response);
      })
      .finally(()=>{
        this.dpLoading = false;
      });
    },
    // startChat(){
    //     window.location
    // },
    // startCall(){
    //   window.location = "tel:495898694"
    // }
  },
};
</script>
